import React from "react";

interface SynergySVGProps {
  width?: number;
  height?: number;
  isDark?: boolean;
  id?: string;
  fill?: string | null;
}

const SynergySVG = ({ width, height, isDark = false, id, fill = null }: SynergySVGProps) => {
  let st1Fill = isDark ? "#FFFFFF" : "#0A1C2B";

  if (fill) st1Fill = fill;

  return (
    <svg
      version="1.1"
      id={id}
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 229.4 56.4"
      //style={{ enableBackground: "new 0 0 229.4 56.4" }}
      xmlSpace="preserve"
    >
      <style type="text/css">
        {" .st0{enable-background:new;} "}
        {` .st1{fill:${st1Fill};} `}
        {fill ? `.st2{fill:${fill};}` : ` .st2{fill:url(#SVGID_1_${id});} `}
        {fill ? ` .st3{fill:${fill};} ` : " .st3{fill:#F00;} "}
      </style>
      <g className="st0">
        <path
          className="st1"
          d="M62.2,30.5c1.5,2.2,4.9,3.8,8.6,3.8c2.9,0,4.4-0.8,4.4-2.2c0-1.6-2.4-1.8-6-2.3c-3.6-0.6-7.5-1.5-7.5-5.1
            c0-3.4,3.3-6,9.1-6c4.7,0,8.4,1.7,10,3.9l-3,2.7c-1.5-1.9-4.2-3-7.6-3c-2.7,0-4.2,0.8-4.2,1.9c0,1.3,1.5,1.5,
            5.3,2c3.9,0.6,8.4,1.4,8.4,5.3c0,3.7-3.5,6.4-9.3,6.4c-5.3,0-9.7-2.1-11.3-4.5L62.2,30.5z"
        />
      </g>
      <g className="st0">
        <path className="st1" d="M98.3,18.9h5.3l-10.9,11l-1.1,7.8h-4.4l1.1-7.8l-7.8-11h5l5.3,7.5L98.3,18.9z" />
      </g>
      <g className="st0">
        <path
          className="st1"
          d="M122.1,37.7h-3.8l-9.9-13.3l-1.9,13.3h-4.2l2.6-18.8h4.4l9.4,12.7l1.8-12.7h4.2L122.1,37.7z"
        />
        <path
          className="st1"
          d="M146.9,18.9l-0.5,3.7h-13.9l-0.5,3.6h12.4l-0.5,3.7h-12.4l-0.6,4h13.9l-0.5,3.7h-18.2l2.6-18.8H146.9z"
        />
        <path
          className="st1"
          d="M151.9,37.7h-4.4l2.6-18.8h11.5c4.3,0,6.9,2.2,6.9,5.6c0,2.9-1.8,5.3-5.1,6.2l3.8,7h-4.8l-3.5-6.7h-6
		         L151.9,37.7z M160.8,27.5c2.2,0,3.6-1.2,3.6-2.7c0-1.3-1-2.2-3-2.2h-7.3l-0.7,4.9H160.8z"
        />
      </g>
      <g className="st0">
        <path
          className="st1"
          d="M192.4,24.6l-4.1,1.6c-0.7-2.3-3.1-3.7-6.3-3.7c-4.3,0-7.2,2.7-7.2,6.3c0,3.5,2.6,5.5,6.5,5.5
            c3,0,5.5-1.3,6.4-3.4h-7.9l0.5-3.6h12.1l-1.4,10.4h-4.1l0.3-1.9c-1.5,1.4-3.5,2.1-6.3,2.1c-6.1,
            0-10.5-3.7-10.5-9c0-5.5,4.8-10.3,12-10.3C187.3,18.6,191.4,21,192.4,24.6z"
        />
      </g>
      <g className="st0">
        <path className="st1" d="M210.2,18.9h5.3l-10.9,11l-1.1,7.8h-4.4l1.1-7.8l-7.8-11h5l5.3,7.5L210.2,18.9z" />
      </g>
      <linearGradient
        id={`SVGID_1_${id}`}
        gradientUnits="userSpaceOnUse"
        x1="24.09"
        y1="30.2484"
        x2="39.25"
        y2="30.2484"
        gradientTransform="matrix(1 0 0 -1 0 58.5984)"
      >
        <stop offset="0%" stopColor="#FF0000" />
        <stop offset="100%" stopColor="#0A1C2B" />
      </linearGradient>
      <path
        className="st2"
        d="M24.2,38.2c2.9-0.1,5.7-1.3,7.7-3.5l7.4-6.4v-9.8c-2.9,0-5.7,1.2-7.6,3.4l-7.5,6.5l0,0L24.2,38.2L24.2,38.2z"
      />
      <path className="st1" d="M24.1,38.2c-5.4,0-9.9-4.4-9.9-9.9c0-5.4,4.4-9.9,9.9-9.9V38.2z" />
      <path className="st3" d="M39.2,18.5c5.4,0,9.9,4.4,9.9,9.9c0,5.4-4.4,9.9-9.9,9.9V18.5z" />
    </svg>
  );
};

interface SynergyNoTextProps {
  width: number;
  height: number;
  id: string;
}

export const SynergyNoText = ({ width, height, id }: SynergyNoTextProps) => (
  <svg viewBox="0 0 221.59 144.73" width={width} height={height}>
    <defs>
      <style type="text/css">
        {` .cls-1{fill:url(#SVGID_1_${id});}  `}
        {" .cls-2{fill:#0a1c2b;} "}
        {" .cls-3{fill:red;} "}
      </style>
      <linearGradient id={`SVGID_1_${id}`} x1="72.37" y1="72.36" x2="149.22" y2="72.36" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="red" />
        <stop offset="100%" stopColor="#0a1c2b" />
      </linearGradient>
    </defs>
    <path
      className="cls-1"
      d="M72.72,122.36c15.46,0,28-7,38.85-17.62l37.65-32.5V22.36c-15.45.05-27.29,6.11-38.61,17.25L72.37,72.69h0v49.67Z"
    />
    <path className="cls-2" d="M72.37,122.36a50,50,0,0,1,0-100Z" />
    <path className="cls-3" d="M149.22,22.36a50,50,0,0,1,0,100Z" />
  </svg>
);

export default SynergySVG;
